import outdent from "outdent";
import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const googleDrive = defineConnector({
  identifier: "googleDrive",
  name: "Google Drive",
  tagLine: "Files and folders",
  logo,
  protocol: "http",
  tags: ["featured", "documents"],
  defaultUrlPattern: () => "https://www\\.googleapis\\.com/(upload/)?drive/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Connect your Google Drive account",
      items: [
        {
          kind: "markdown",
          content: outdent`
            ⚠️ Currently, Google Drive OAuth access is available in limited preview.

            Please reach out to your Tines contact in order to have it enabled for your specific email address. Until then, authorization will be denied.
          `,
        },
        {
          kind: "oauth",
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://accounts.google.com/o/oauth2/v2/auth",
    tokenEndpoint: () => "https://oauth2.googleapis.com/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "managed",
    scopes: () => [
      "openid",
      "email",
      "profile",
      "https://www.googleapis.com/auth/drive",
    ],
    authorizationParameters: () => ({
      access_type: "offline",
      prompt: "consent",
    }),
  },
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://www.googleapis.com/drive/v3/about?fields=user",
    }),
  },
});
